import { IntlProvider, addLocaleData } from "react-intl";
import pt from 'react-intl/locale-data/pt';

export const initIntl = callback => {
  if(window.Intl) {
    addLocaleData(pt);
    callback();
    return;
  }
};

export const getIntlProviderConfig = (fetchedLocale) => {
  const intlProvider = {
    locale: "pt",
    messages: flattenMessages(fetchedLocale),
  };

  sessionStorage.setItem("__stip_port_locales", JSON.stringify(intlProvider));
  return intlProvider;
};

export function getFormattedMessage(id) {
  const config = JSON.parse(sessionStorage.getItem("__stip_port_locales"));

  return new IntlProvider(config, {})
    .getChildContext()
    .intl.formatMessage({ id });
}

export const flattenMessages = (nestedMessages, prefix = "") =>
  Object.keys(nestedMessages).reduce((messages, key) => {
    let value = nestedMessages[key];
    let prefixedKey = prefix ? `${prefix}.${key}` : key;

    typeof value === "string"
      ? (messages[prefixedKey] = value)
      : Object.assign(messages, flattenMessages(value, prefixedKey));

    return messages;
  }, {});
